import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import axios from 'axios';
export var RetCode = /*#__PURE__*/function (RetCode) {
  RetCode[RetCode["Success"] = 0] = "Success";
  RetCode[RetCode["GeneralError"] = 10000] = "GeneralError";
  RetCode[RetCode["RedisStorageError"] = 11501] = "RedisStorageError";
  RetCode[RetCode["StorageError"] = 11629] = "StorageError";
  RetCode[RetCode["LoginError"] = 12100] = "LoginError";
  RetCode[RetCode["AuthError"] = 12607] = "AuthError";
  RetCode[RetCode["FileHasBeenDeleted"] = 12909] = "FileHasBeenDeleted";
  RetCode[RetCode["UserInfoError"] = 15706] = "UserInfoError";
  RetCode[RetCode["SizeLimitOwner"] = 20010] = "SizeLimitOwner";
  RetCode[RetCode["SizeLimitCollaborator"] = 20013] = "SizeLimitCollaborator";
  RetCode[RetCode["IndependentPasswordRequired"] = 20062] = "IndependentPasswordRequired";
  RetCode[RetCode["XSRF"] = 11007] = "XSRF";
  return RetCode;
}({});

/**
 * drive 后台 v1 接口的统一返回数据结构
 *
 * 此类接口的结构没有 result 这一层，简单地把业务数据组织在平铺的结构里
 */

/**
 * drive 后台 v2 接口的统一返回数据结构
 *
 * 此类接口回包里封装了 ret 和 header，把业务数据封装在 result 里面
 */

/**
 * 请求后台 v1 的接口
 */
export function requestV1Cgi(_x) {
  return _requestV1Cgi.apply(this, arguments);
}

/**
 * 请求后台 v2 的接口
 */
function _requestV1Cgi() {
  _requestV1Cgi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
    var res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return axios.request(payload);
        case 2:
          res = _context.sent;
          return _context.abrupt("return", _objectSpread({
            traceId: res.headers['x-trace-id']
          }, res.data));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _requestV1Cgi.apply(this, arguments);
}
export function requestV2Cgi(_x2) {
  return _requestV2Cgi.apply(this, arguments);
}
function _requestV2Cgi() {
  _requestV2Cgi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(payload) {
    var res;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return axios.request(payload);
        case 2:
          res = _context2.sent;
          return _context2.abrupt("return", _objectSpread({
            traceId: res.headers['x-trace-id']
          }, res.data));
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _requestV2Cgi.apply(this, arguments);
}
//# sourceMappingURL=network-request.js.map